import { unenrollAutomaticPaymentData } from "constants-lib/seo/unenrollAutomaticPaymentData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getUnenrollAutomaticPayment = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Unenroll Automatic Payment JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addUnenrollAutomaticPayment = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-to-unenroll-from-automatic-payments-autopay`,
    ) &&
    document.getElementById(`unenrollAutomaticPayment`) === null
  ) {
    const script = unenrollAutomaticPaymentJSONLD()
    addJSONLDToHead(script, `unenrollAutomaticPayment`)
  } else {
    removeElement(`unenrollAutomaticPayment`)
  }
}

// JSON LD template for Unenroll Automatic Payment
const unenrollAutomaticPaymentJSONLD = () => {
  const unenrollAutomaticTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getUnenrollAutomaticPayment(unenrollAutomaticPaymentData),
  }
  return unenrollAutomaticTemplate
}
